import React from 'react';
import Text from './Text';
import Links from './Links';

export default function FaqFooter({
  showText,
  showLinks,
}: {
  showText: boolean;
  showLinks: boolean;
}): JSX.Element {
  return (
    <div>
      {showText && <Text />}
      {showLinks && <Links />}
    </div>
  );
}
